export default "__VITE_PUBLIC_ASSET__bcf97aee__"